// Bridge that lets non-React code (the axios interceptor) flip the app into the
// Permission Denied state when the API returns 403. Mirrors errors/globalError.

let setForbiddenRef: (() => void) | null = null;

export const registerGlobalForbiddenSetter = (fn: () => void) => {
  setForbiddenRef = fn;
};

export const pushGlobalForbidden = () => {
  if (setForbiddenRef) setForbiddenRef();
};

export const unregisterGlobalForbiddenSetter = () => {
  setForbiddenRef = null;
};
